// extracted by mini-css-extract-plugin
export default {"heading":"Header_heading__ni+IL","light":"Header_light__1SvF+"};